module.exports = __webpack_public_path__ + "static/media/Background.76084b2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/v2/Background/Background.png
// module id = 385
// module chunks = 4 8